import React from 'react'
import Totalemployers from '../../component/Menu/TotalEmployers'
export default function TotalEmployers() {
    return (
        <React.Fragment>
            <Totalemployers />
        </React.Fragment>
    )
}
